import React from "react";
import {FormControlLabel, FormLabel, Grid, Radio, RadioGroup} from "@mui/material";
import VariabiliGlobali from "../../Back/VariabiliGlobali";
import axios from "axios";
import {ReactSession} from "react-client-session";

class FiltroSceltaNegozio extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            visualizzaMaga: props.visualizzaMaga,
            sceltaneg: props.sceltaneg,
            visualizzaTutti: props.visualizzaTutti,
            negozi: [],
            negozi2: []
        }
        this.idmagazzino = ReactSession.get("idmagazzino");
    }

    componentDidMount() {
        this.handleChange = this.handleChange.bind(this);
        this.handlechange2 = this.handlechange2.bind(this);
        this.handlechange2(this.state.sceltaneg)
        this.chiediNegozi();
        this.chiediNegozi2();
    }

    chiediNegozi() {
        const params = new URLSearchParams();
        params.append('idmagazzino', this.idmagazzino);
        const config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            }
        }
        const url = VariabiliGlobali.indirizzoIP + VariabiliGlobali.porta + '/controllonegozi/dammiNomeNegozi';
        axios.post(url, params, config)
            .then((response) => {
                this.setState({negozi: response.data})
            })
            .catch((error) => {
                console.log('Errore: ' + error);
                alert(JSON.stringify(error))
            })
    }

    chiediNegozi2() {
        const params = new URLSearchParams();
        params.append('idmagazzino', this.idmagazzino);
        params.append('escludiMaga', true);
        const config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            }
        }
        const url = VariabiliGlobali.indirizzoIP + VariabiliGlobali.porta + '/controllonegozi/dammiNomeNegozi';
        axios.post(url, params, config)
            .then((response) => {
                this.setState({negozi2: response.data})
            })
            .catch((error) => {
                console.log('Errore: ' + error);
                alert(JSON.stringify(error))
            })
    }

    handleChange(e) {
        this.props.cambiaNegozio(e.target.value);
        this.setState({sceltaneg: e.target.value})
    }

    handlechange2(variabile) {
        this.props.cambiaNegozio(variabile);
        this.setState({sceltaneg: variabile})
    }


    render() {
        if (this.state.visualizzaMaga.toString() === 'true') {
            return (
                <Grid container spacing={3}>
                    <Grid item>
                        <FormLabel component="legend">Scelta negozio</FormLabel>
                        <RadioGroup spacing={3} row aria-label="Scelta negozio" name="sceltaneg"
                                    value={this.state.sceltaneg}
                                    onChange={(e) => this.handleChange(e)}>
                            {this.getNegoziGrafica()}
                            {this.state.visualizzaTutti === true && (
                                <FormControlLabel value={"Tutti"} control={<Radio/>} label={"Tutti"}/>
                            )}
                        </RadioGroup>
                    </Grid>
                </Grid>
            );
        } else {
            return (
                <Grid container spacing={3}>
                    <Grid item>
                        <FormLabel component="legend">Scelta negozio</FormLabel>
                        <RadioGroup spacing={3} row aria-label="Scelta negozio" name="sceltaneg"
                                    value={this.state.sceltaneg}
                                    onChange={(e) => this.handleChange(e)}>
                            {this.getNegoziGrafica2()}
                            {this.state.visualizzaTutti === true && (
                                <FormControlLabel value={"Tutti"} control={<Radio/>} label={"Tutti"}/>
                            )}
                        </RadioGroup>
                    </Grid>
                </Grid>
            );
        }
    }

    getNegoziGrafica = function () {
        return this.state.negozi.map((el, i) =>
            <FormControlLabel value={el.idasterneg} control={<Radio/>} label={el.nome}/>
        )
    }

    getNegoziGrafica2 = function () {
        return this.state.negozi2.map((el, i) =>
            <FormControlLabel value={el.idasterneg} control={<Radio/>} label={el.nome}/>
        )
    }
}

export default FiltroSceltaNegozio
